import React from 'react';
import "tabler-react/dist/Tabler.css";
import { Page, Icon } from "tabler-react";

import CardTablaPlataformas from "./CardTablaPlataformas";

function IngresoPlataformas() {
  return (
    <>
      <Page.Content className="page-ingreso-plataformas">
        <Page.Title><Icon prefix="fe" name="log-in" />Ingresar a Plataformas</Page.Title>
        <CardTablaPlataformas />
      </Page.Content>
    </>
  );
}

export default IngresoPlataformas;